import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBYi6pqdMhh2YdNsqx1tdGfpnDbNeMFmT0",
  authDomain: "fantasticdap.firebaseapp.com",
  projectId: "fantasticdap",
  storageBucket: "fantasticdap.appspot.com",
  messagingSenderId: "136113037273",
  appId: "1:136113037273:web:6e66710288e97a0e1143c8",
  measurementId: "G-QXKVQVQJ92"
};

firebase.initializeApp(firebaseConfig);
export default firebase;